const routes = {
  authenticate: '/authenticate',
  login: '/authenticate/login',
  loginInvitation: '/authenticate/invitation',
  signup: '/authenticate/signup',
  loginOtp: '/authenticate/login-otp',
  resetPassword: '/authenticate/reset-password',
  createPassword: '/authenticate/create-password',
  forgotPassword: '/authenticate/forgot-password',
  createCompany: '/create-company',

  logout: '/logout',
  policy: '/policy',
  terms: '/terms-and-conditions',

  home: '/home',
  onboarding: '/onboarding-list',

  finalizeBilling: '/finalize-billing',
  billing: '/profile/billing',
  subscription: '/subscription',

  workingDay: '/working-day',

  workforce: '/workforce',
  suppliers: '/workforce/suppliers',
  contracts: '/workforce/contracts',
  workersTimesheet: '/workforce/workers-timesheet',

  // packhouse
  printingOrders: '/packhouse/printing-orders',

  settlements: '/accounts/settlements',
  workingDayReconciliation: '/accounts/settlements-working-day-reconciliation',
  periodicJobs: '/periodic-jobs',
  createPeriodicJob: '/periodic-jobs/create',
  warehouseManagement: '/warehouse-management',
  warehouses: '/warehouse-management/warehouses',
  inboundDeliveryDetails:
    '/warehouse-management/warehouses/inbound-delivery/[id]',
  returnRequestDetails: '/warehouse-management/returns/[id]',
  deletedInboundDeliveries:
    '/warehouse-management/warehouses/[id]/deleted-list',
  dispatchRequests: '/warehouse-management/dispatch-requests',
  newDispatchRequests:
    '/warehouse-management/dispatch-requests/add-dispatch-request',
  addNewStock: '/warehouse-management/warehouses/add-new-stock',
  returns: '/warehouse-management/returns',
  custody: '/warehouse-management/custody',
  settings: '/settings',
  statistics: '/statistics',
  companySettings: '/settings/company',
  propertySettings: '/settings/property',
  companyTeamSettings: '/settings/team',
  approvalsSettings: '/settings/approvals',
  inactiveLists: '/settings/company/inactive-lists',
  propertyInactiveLists: '/settings/property/inactive-lists',
  inactiveWorkers: '/workforce/suppliers/[id]/inactive-workers',
  instructions: '/instructions',
  aydiIntelligence: '/aydi-intelligence',
};
export const publicRoutes = [
  routes.signup,
  routes.login,
  routes.loginInvitation,
  routes.loginOtp,
  routes.resetPassword,
  routes.createPassword,
  routes.forgotPassword,
  routes.onboarding,
  routes.instructions,
  routes.policy,
  routes.terms,
  routes.finalizeBilling,
];
export default routes;
